// extracted by mini-css-extract-plugin
export default {"loadingElement":"loading_loadingElement__nf02u"};